import React, { useEffect, useState, useMemo } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { useProductCategory } from "./hooks/useProductCategory";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "../common/ImageViewer";
import { InputField, SelectField, ImageUploadField } from ".././FormFields";
import { validateImageFile } from "utils/common";
export default function ProductCategoryForm({ initialData, onSubmit }) {
  const { categories, loadCategoriesByOrganizer } = useProductCategory();

  const companyId = localStorage.getItem("company_id");
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    title: "",
    parent_id: "",
    image: null,
  });

  const [viewerOpen, setViewerOpen] = useState(false);

  useEffect(() => {
    if (companyId) {
      loadCategoriesByOrganizer(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        parent_id: initialData.parent_id || "",
        image: initialData.image || null,
      });
    }
  }, [initialData]);

  const parentCategories = useMemo(
    () => flattenCategories(categories || []),
    [categories]
  );

  const submit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("title", form.title);
    payload.append("company_id", companyId);
    payload.append("parent_id", form.parent_id || "");

    if (form.image && typeof form.image !== "string") {
      payload.append("image", form.image);
    }

    await onSubmit(payload);
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const { isValid, error } = await validateImageFile(file, 1);

    if (!isValid) {
      setErrors((prev) => ({ ...prev, image: error }));
      return; // Stop execution if validation fails
    }

    // 2. Clear error and update state if valid
    setErrors((prev) => ({ ...prev, image: "" }));
    if (file) {
      setForm((prev) => ({ ...prev, image: file }));
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <SelectField
        label="Parent Category"
        name="parent_id"
        value={form.parent_id || ""}
        onChange={(e) => setForm({ ...form, parent_id: e.target.value })}
        options={(parentCategories || []).map((item) => ({
          value: item._id,
          label: item.title,
        }))}
        placeholder="Search category..."
        isSearchable={true}
      />
      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Parent Category
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.parent_id}
          onChange={(e) => setForm({ ...form, parent_id: e.target.value })}
        >
          <option value="">Parent Category (Optional)</option>
          {parentCategories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.title}
            </option>
          ))}
        </select>
      </div> */}
      <InputField
        label="Category Title"
        name="title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
        required
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Category Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="Category Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />
      </div> */}
      <ImageUploadField
        label="Image"
        name="eventBanner"
        recommended={
          <>
            Recommended resolution: 393 × 219 px. Accepted formats: JPEG, PNG.
          </>
        }
        preview={
          form.image && typeof form.image === "string"
            ?  getImageUrl(form.image)
            :URL.createObjectURL(form.image)
        }
        onUpload={handleFile}
        error={errors.image}
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Image
          <span className="ml-2 text-xs font-normal text-gray-500">
            (Recommended resolution: 393 × 219 px. Accepted formats: JPEG, PNG.
            )
          </span>
        </label>

        <input
          type="file"
          accept="image/*"
          className="w-full rounded border p-2"
          onChange={handleFile}
        />

        {form.image && typeof form.image === "string" && (
          <>
            <img
              src={getImageUrl(form.image)}
              alt="Category"
              className="mt-2 h-24 cursor-pointer rounded border object-contain"
              onClick={() => setViewerOpen(true)}
            />
            <ImageViewer
              open={viewerOpen}
              onClose={() => setViewerOpen(false)}
              src={getImageUrl(form.image)}
            />
          </>
        )}
      </div> */}
      <div className=" mt-4 flex justify-end">
        <button className="btn-primary">
          {initialData ? "Update" : "Save"}
        </button>
      </div>
    </form>
  );
}
